import React, { useRef } from 'react';
import { ChartPaletteProvider } from 'contexts/ChartPaletteContext';
import V5Gadget from './V5Gadget';
import ErrorBoundary from '../Common/ErrorBoundary';
import GqlClientProvider from '../../contextProviders/SplashScreenProviders/UserAndAccountProviders/GqlClientProvider';
import EnsureChartColorsProvider from './EnsureChartColorsProvider';

const V5GadgetContainer = ({
  chartDefinition,
  useSmallNoDataMessage,
}: {
  chartDefinition: V5ChartDefinition;
  useSmallNoDataMessage?: boolean;
}) => {
  const chartRef = useRef<any>();
  return (
    <GqlClientProvider
      visName={chartDefinition.name}
      visId={chartDefinition.id}
      visType={chartDefinition.gadgetType}
    >
      <ErrorBoundary>
        <ChartPaletteProvider chartDefinition={chartDefinition}>
          <EnsureChartColorsProvider>
            <V5Gadget
              chartDefinition={chartDefinition}
              chartRef={chartRef}
              useSmallNoDataMessage={useSmallNoDataMessage || false}
            />
          </EnsureChartColorsProvider>
        </ChartPaletteProvider>
      </ErrorBoundary>
    </GqlClientProvider>
  );
};

export default V5GadgetContainer;
